import { render, staticRenderFns } from "./DatingNoMannerPage.vue?vue&type=template&id=da389b78&scoped=true"
import script from "./DatingNoMannerPage.vue?vue&type=script&lang=js"
export * from "./DatingNoMannerPage.vue?vue&type=script&lang=js"
import style0 from "./DatingNoMannerPage.vue?vue&type=style&index=0&id=da389b78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da389b78",
  null
  
)

export default component.exports